import { apiFetch } from './client'
import type { AllocationSimulationResponse } from '../types/simulation'
import type { StrategyMode } from '../types/strategy'

export function simulateAllocation(
  usdcAmount: string,
  mode: StrategyMode
): Promise<AllocationSimulationResponse> {
  return apiFetch<AllocationSimulationResponse>('/api/strategy/simulate', {
    method: 'POST',
    body: JSON.stringify({ usdcAmount, mode }),
  })
}
